import { render, staticRenderFns } from "./UnderReview.vue?vue&type=template&id=1ba9c09f&scoped=true"
import script from "./UnderReview.vue?vue&type=script&lang=js"
export * from "./UnderReview.vue?vue&type=script&lang=js"
import style0 from "./UnderReview.vue?vue&type=style&index=0&id=1ba9c09f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba9c09f",
  null
  
)

export default component.exports